import * as React from "react";
import { Modal, ProgressBar, Form, Container, Button, Spinner } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import _ from "lodash";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { DropDownList } from "../../Reports/common-components/dropdown-list";
import { Utils } from "../../../Common/Utilis";
import { DataImportRules as dataimportService } from "../../../Common/Services/DataImportRule";
import Dropzone from 'react-dropzone';
import "./PriorDataImport.scss";
import { CommonService } from "../../../Common/Services/CommonService";
export class PriorDataImport extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            isPermission: "No",
            tenantsList: [],
            tenantData: {
                userUniqueno: this.props?.userUniqueNo,
                tenant: 0
            },
            PriorDataValidation: [],
            isError: false,
            hotelList: [],
            hotelData: {
                hotelID: 0,
                lettercode: ""
            },
            isRetrieveDisabled: true,
            isShowpopup: false,
            isProgress: Math.floor(Math.random() * 30),
            uploadFiles: [],
            BlobbaseUrl: "",
        };
    }

    componentDidMount() {
        this.getBlobbaseUrl();
        let storage = JSON.parse(localStorage.getItem("storage")!);
        let tenantID = storage === null ? 0 : storage.tenantID;
        if (tenantID !== 230) {
            window.location.href = "/unauthorize-access";
        } else {
            this.setState({ isPermission: "Yes" },
                () => this.getTenantsList()
            )
        }
    }

    getBlobbaseUrl = () => {
        let keyName = "BlobbaseUrl";
        let BlobbaseUrl = "";
        CommonService.GetInnflowConfigKeyValue(keyName)
            .then(async (result: any | null) => {
                console.log(result);
                if (result !== null) {
                    BlobbaseUrl = result;
                    this.setState({ BlobbaseUrl: BlobbaseUrl });
                }
            });
    }


    getTenantsList = () => {
        dataimportService.GetTenantsList()
            .then(async (result: any | null) => {
                if (result.length > 0) {
                    result.map((items) => ((items["tenant"] = items.tenantid)));
                    this.setState({ tenantsList: [] }, () =>
                        this.setState({ tenantsList: result })
                    )
                }
                else {
                    this.setState({ tenantsList: [] });
                }
                resolve();
            })
            .catch((error) => {
                this.setState({ tenantsList: [] }, () => {
                    Utils.toastError(error.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "PriorDataImport",
                    });
                });
                reject();
            })


    }

    handleTenantChange = (event, inputPosition, isBlur = false) => {
        const { tenantData, hotelData } = this.state;
        let value = event.target.value;
        const fieldName = event.target.name;
        tenantData[fieldName] = value;
        hotelData.hotelID = 0;
        hotelData.lettercode = "";

        this.setState({
            hotelList: [], hotelData, isRetrieveDisabled: true, uploadFiles: [], PriorDataValidation: [], isProgress: Math.floor(Math.random() * 30),
        }, () => {
            this.getHotelsListFromTenantId(value);
        });
    }

    getHotelsListFromTenantId = (selectedTenantId) => {
        let request: any = {};
        request.selectedtenantID = selectedTenantId;
        request.tenantID = 0;
        dataimportService.GetHotelList(request)
            .then(async (result: any | null) => {
                if (result.length > 0) {
                    debugger;
                    result = result.filter(e => e.hotelType === "2");
                    this.setState({ hotelList: [] }, () =>
                        this.setState({ hotelList: result })
                    )
                }
                else {
                    this.setState({ hotelList: [] });
                }
                resolve();
            })
            .catch((error) => {
                this.setState({ hotelList: [] }, () => {
                    Utils.toastError(error.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "PriorDataImport",
                    });
                });
                reject();
            })
    }

    onEhidChange = (event, inputPosition, isBlur = false) => {
        this.setState({ uploadFiles: [], isProgress: Math.floor(Math.random() * 30), })
        const { tenantData: { tenant }, hotelData } = this.state;
        let name = event.target.name;
        let value = event.target.value;
        hotelData.hotelID = name;
        hotelData.lettercode = value;
        this.setState({ isRetrieveDisabled: false })

    }

    GetDataValidation = () => {
        const { tenantData: { tenant }, hotelData: { hotelID }, isError } = this.state;
        let request: any = {};
        request.HTenantId = tenant;
        request.Hid = hotelID;
        dataimportService.GetPriorDataValidation(request)
            .then(async (result: any | null) => {
                if (result.success) {

                    let filteredResult = result.result || [];
                    debugger;
                    // Check if any item has a blank itemname
                    const hasBlankItemName = filteredResult.some((item: any) => !item.itemName || item.itemName.trim() === "");


                    this.setState({ PriorDataValidation: [] }, () => {
                        this.setState({ PriorDataValidation: result.result, isRetrieveDisabled: hasBlankItemName ? true : isError })
                    })
                } else {
                    this.setState({ PriorDataValidation: [], isRetrieveDisabled: true })
                }
                resolve();
            })
            .catch((error) => {
                this.setState({ isRetrieveDisabled: true }, () => {
                    Utils.toastError(error.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "PriorDataImport",
                    });
                });
                reject();
            })
    }

    importData = () => {
        this.setState({ PriorDataValidation: [], isShowpopup: true, uploadFiles: [], isProgress: Math.floor(Math.random() * 30), })
    }

    onDrop = (uploadFiles: any) => {
        if (uploadFiles.length === 1) {
            this.setState({ uploadFiles, isError: false }, () => {
                this.importPriorFile();
            });
        } else if (uploadFiles.length > 1) {
            Utils.toastError("Multiple files are not allowed.", {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        } else {
            Utils.toastError("Only .xlsx and .csv files are acceptable.", {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        }
    }

    importPriorFile = () => {

        const { tenantData: { tenant }, hotelData: { hotelID } } = this.state;
        let request: any = {};
        request.TenantId = tenant;
        request.HotelId = hotelID;

        dataimportService.PriorDataImportFile(request, this.state.uploadFiles)
            .then(async (result: any) => {
                if (result.success) {
                    debugger;
                    if (result.message == "Success") {
                        debugger;
                        this.setState({ isProgress: 100 })
                        setTimeout(() => {

                            this.GetDataValidation();
                            this.setState({ importList: [] }, () => {
                                this.setState({ isShowpopup: false, importList: result.result, isError: false });
                            });

                        }, 1000);
                    }
                    else if (result.message == "SuccessRevenue") {
                        debugger;
                        this.setState({ isProgress: 100 })
                        setTimeout(() => {

                            this.setState({ PriorDataValidation: [], DataList: [], spinnerLoading: false, isRetrieveDisabled: false, isError: false })
                            Utils.toastSuccess("Data has imported successfully.", { position: toast.POSITION.BOTTOM_RIGHT, });



                        }, 1000);
                    }
                    else {
                        setTimeout(() => {
                            this.setState({ isShowpopup: false, isRetrieveDisabled: true, isError: true }, () => {
                                if (result.message == "ErrorManual") {
                                    this.setState({ isShowpopup: false, PriorDataValidation: [], isRetrieveDisabled: true });
                                    Utils.toastSuccess("Manual entries found!!!.", { position: toast.POSITION.BOTTOM_RIGHT, });

                                }
                                else if (result.message == "StartDateMsg") {
                                    this.setState({ isShowpopup: false, PriorDataValidation: [], isRetrieveDisabled: false });
                                    Utils.toastSuccess("Data has imported successfully. Please update the room start date to a value prior than the earliest imported date.", { position: toast.POSITION.BOTTOM_RIGHT, });


                                }
                                else {
                                    this.GetDataValidation();
                                }
                            });
                            if (result.message != "ErrorManual" && result.message != "StartDateMsg")

                                Utils.toastError(result.message, { position: toast.POSITION.BOTTOM_RIGHT, });
                        }, 1000);
                    }

                } else {
                    setTimeout(() => {
                        this.setState({ isShowpopup: false }, () => {
                            if (result.message == "ErrorManual") {
                                this.setState({ isShowpopup: false, PriorDataValidation: [] });
                                Utils.toastSuccess("Manual entries found!!!.", { position: toast.POSITION.BOTTOM_RIGHT, });

                            }
                            else if (result.message == "StartDateMsg") {
                                this.setState({ isShowpopup: false, PriorDataValidation: [] });
                                Utils.toastSuccess("Data has imported successfully. Please update the room start date to a value prior than the earliest imported date.", { position: toast.POSITION.BOTTOM_RIGHT, });


                            }
                            else {

                                this.GetDataValidation();
                            }
                        });
                        if (result.message != "ErrorManual" && result.message != "StartDateMsg")
                            Utils.toastError(result.message, { position: toast.POSITION.BOTTOM_RIGHT, });
                    }, 1000);
                }
                resolve();
            })
            .catch((error) => {
                setTimeout(() => {
                    this.setState({ isShowpopup: false })
                }, 1000);
                let resMessage = "Something went wrong.";
                setTimeout(() => { Utils.toastError(resMessage, { position: toast.POSITION.BOTTOM_RIGHT, }); }, 1000);
                reject();
            });
    }


    cancelImport = () => {

        this.setState({ isShowpopup: false, PriorDataValidation: [], DataList: [], isRetrieveDisabled: true, spinnerLoading: false, });
    }

    importFinalPriorData = () => {
        const { tenantData: { tenant }, hotelData: { hotelID }

        } = this.state;


        let DataList = this.state.importList;
        debugger;
        if (DataList != undefined) {
            this.setState({ spinnerLoading: true });
            let request: any = {};
            request.HTenantId = tenant;
            request.Hid = hotelID;
            request.uniqueno = DataList.uniqueno;
            request.oprid = DataList.oprid;
            request.coa = DataList.coa;
            request.roomcountDate = DataList.roomcountDate;
            request.minDate = DataList.minDate;
            dataimportService.InsertPriorDataFinal(request)
                .then(async (result: any) => {
                    if (result.success) {
                        if (result.message == "Success") {
                            debugger;
                            this.setState({ isProgress: 100 })
                            setTimeout(() => {
                                this.setState({ PriorDataValidation: [], DataList: [], spinnerLoading: false, isRetrieveDisabled: false, isError: false })
                                Utils.toastSuccess("Data has imported successfully.", { position: toast.POSITION.BOTTOM_RIGHT, });


                            }, 1000);
                        } else {
                            setTimeout(() => {
                                this.setState({ isShowpopup: false, }, () => {
                                    if (result.message == "ErrorManual") {
                                        this.setState({ isShowpopup: false, PriorDataValidation: [], isRetrieveDisabled: true });
                                        Utils.toastSuccess("Manual entries found!!!.", { position: toast.POSITION.BOTTOM_RIGHT, });

                                    }
                                    else if (result.message == "StartDateMsg") {
                                        this.setState({ isShowpopup: false, PriorDataValidation: [], isRetrieveDisabled: true });
                                        Utils.toastSuccess("Prior data has already been imported. Please update the room start date to be later than the earliest imported date.", { position: toast.POSITION.BOTTOM_RIGHT, });


                                    }
                                    else {
                                        this.GetDataValidation();
                                    }
                                });
                                if (result.message != "ErrorManual" && result.message != "StartDateMsg")
                                    Utils.toastError(result.message, { position: toast.POSITION.BOTTOM_RIGHT, });
                            }, 1000);
                        }

                    } else {
                        setTimeout(() => {
                            this.setState({ isShowpopup: false }, () => {
                                if (result.message == "ErrorManual") {
                                    this.setState({ isShowpopup: false, PriorDataValidation: [], isRetrieveDisabled: true });
                                    Utils.toastSuccess("Manual entries found!!!.", { position: toast.POSITION.BOTTOM_RIGHT, });

                                }
                                else if (result.message == "StartDateMsg") {
                                    this.setState({ isShowpopup: false, PriorDataValidation: [], isRetrieveDisabled: true });
                                    Utils.toastSuccess("Prior data has already been imported. Please update the room start date to be later than the earliest imported date.", { position: toast.POSITION.BOTTOM_RIGHT, });


                                }
                                else {

                                    this.GetDataValidation();
                                }
                            });
                            if (result.message != "ErrorManual" && result.message != "StartDateMsg")
                                Utils.toastError(result.message, { position: toast.POSITION.BOTTOM_RIGHT, });
                        }, 1000);
                    }
                    resolve();
                })
                .catch((error) => {
                    setTimeout(() => {
                        this.setState({ isShowpopup: false, isRetrieveDisabled: true })
                    }, 1000);
                    let resMessage = "Something went wrong.";
                    setTimeout(() => { Utils.toastError(resMessage, { position: toast.POSITION.BOTTOM_RIGHT, }); }, 1000);
                    reject();
                });
        }
    }
    PriorDataImportFileClose = () => {
        this.setState({ isShowpopup: false, uploadFiles: [], isProgress: Math.floor(Math.random() * 30), });
    }

    errorFormatter(cell: any, row: any, rowIndex: any) {
        return (
            <div className="error-msg">{row.itemName === "" ? "Invalid " + row.type : ""}</div>
        );
    }

    downloadTemplate = () => {
        let BlobbaseUrl = this.state.BlobbaseUrl;
        //'https://innflowfilestoretest.blob.core.windows.net/innflowtemplate/PriorDataImport.xlsx'
        fetch(BlobbaseUrl + 'innflowtemplate/PriorDataImport.xlsx', {
            method: 'GET', headers: { 'Content-Type': 'application/vnd.ms-excel' }
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `PriorDataImport.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
    }

    render() {
        const { tenantsList, hotelList, isPermission, isRetrieveDisabled, PriorDataValidation,
            tenantData: {
                tenant
            },
            hotelData: {
                hotelID
            }
        } = this.state;

        const files = this.state.uploadFiles.map(file => (
            <li key={file.name}>
                <div className="d-flex align-items-center">
                    <div className="file-name">{file.name}</div>
                    <div className="file-loader mr-auto"><ProgressBar variant="success" now={this.state.isProgress} /></div>
                    <div className="file-percentage">{this.state.isProgress} %</div>
                </div>
            </li>
        ));

        const columns = [
            {
                dataField: "type",
                text: "Type",
            },
            {
                dataField: "itemName",
                text: "Mapping",
            }, {
                dataField: "itemNo",
                text: "PMS Item No.",
            }, {
                dataField: "coa",
                text: "COA",
            }, {
                dataField: "",
                text: "Error",
                formatter: this.errorFormatter
            },
        ];

        return (
            <>
                <Container fluid className="body-sec PriorDataImport p-0">
                    <ToastContainer
                        autoClose={3000}
                        containerId={"PriorDataImport"}
                        enableMultiContainer
                    />
                    {isPermission === "Yes" && (
                        <>
                            {/* <div className="page-heading underline d-flex">
                                <div className="mr-auto d-flex align-items-center">Prior Data Import</div>
                            </div> */}
                            <div className="main-Page">
                                <div className="bdy-sec">
                                    <div className="search-header">
                                        <div className="filter-section d-flex align-items-end">
                                            <Form.Group controlId="tenant" >
                                                <Form.Label className="IILabel">Tenant</Form.Label>
                                                {(tenantsList && tenantsList.length > 0 &&
                                                    <DropDownList
                                                        defaultTextColor={true}
                                                        placeHolder={"Search Tenant"}
                                                        data={tenantsList}
                                                        isSearchRequired={true}
                                                        label={"tenant"}
                                                        value={"tenantid"}
                                                        onDropDownChange={(item) => {
                                                            if (!item) {
                                                                return;
                                                            }
                                                            this.handleTenantChange(
                                                                Utils.BuildCustomEventObject(
                                                                    "tenant",
                                                                    item.tenantid
                                                                ),
                                                                1
                                                            );
                                                        }}
                                                        selectedItem={[
                                                            ...[{ tenantid: 0, tenant: "Select Tenant" }],
                                                            ...tenantsList,
                                                        ].find((r) => +r.tenantid === tenant)}
                                                    />
                                                )}
                                            </Form.Group>
                                            {(hotelList && hotelList.length > 0 &&
                                                <Form.Group controlId="ehid" >
                                                    <Form.Label className="IILabel">EHID</Form.Label>
                                                    {(hotelList && hotelList.length > 0 &&
                                                        <DropDownList
                                                            defaultTextColor={true}
                                                            placeHolder={"Search EHID"}
                                                            data={hotelList}
                                                            isSearchRequired={true}
                                                            label={"lettercode"}
                                                            value={"hotelID"}
                                                            onDropDownChange={(item) => {
                                                                if (!item) {
                                                                    return;
                                                                }
                                                                this.onEhidChange(
                                                                    Utils.BuildCustomEventObject(
                                                                        item.hotelID,
                                                                        item.lettercode
                                                                    ),
                                                                    1
                                                                );
                                                            }}
                                                            selectedItem={[
                                                                ...[{ hotelID: 0, lettercode: "Select EHID" }],
                                                                ...hotelList,
                                                            ].find((r) => +r.hotelID === hotelID)}
                                                        />
                                                    )}
                                                </Form.Group>
                                            )}
                                            <Form.Group controlId="button">
                                                <Button variant="primary"
                                                    onClick={this.importData}
                                                    disabled={hotelID === 0 || tenant === 0}
                                                >Select File</Button>
                                            </Form.Group>
                                        </div>
                                    </div>
                                    {PriorDataValidation.length > 0 &&
                                        <>
                                            <BootstrapTable
                                                keyField='rno'
                                                data={PriorDataValidation}
                                                columns={columns}
                                                noDataIndication="No matching record found"
                                            />

                                            <div>
                                                <Form.Group controlId="button">
                                                    <Button
                                                        variant="secondary"
                                                        onClick={this.cancelImport}
                                                    >
                                                        Cancel
                                                    </Button>
                                                    {' '}
                                                    <Button
                                                        variant="primary"
                                                        onClick={this.importFinalPriorData}
                                                        disabled={isRetrieveDisabled}
                                                    >
                                                        {this.state.spinnerLoading ? <Spinner animation="border" size="sm" /> : <></>}
                                                        Import
                                                    </Button>
                                                </Form.Group>
                                            </div>

                                        </>
                                    }


                                </div>
                            </div>
                        </>
                    )}
                </Container>
                <Modal className={"import-credit-card-modal"}
                    centered
                    show={this.state.isShowpopup}
                    onHide={this.PriorDataImportFileClose}
                    backdrop="static"
                    dialogClassName={"modal-60w"}
                    aria-labelledby="contained-modal-title-vcenter">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <>Prior Data Import<div className="sub-heading">{this.state.uploadFiles[0]?.path}</div></>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className={"NoScroll"}>
                        <Dropzone onDrop={this.onDrop} accept=".xlsx,.csv" multiple={false}>
                            {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                <>
                                    {this.state.uploadFiles.length == 0 && (
                                        <section className={isDragActive ? "container upload-area default drag-active " : "container upload-area default"}>
                                            <div {...getRootProps({ className: 'dropzone d-flex align-items-center' })}>
                                                <input {...getInputProps()} />
                                                <p>Drag and drop here to start <br /><strong className="acceptedFiles">.xlsx or .csv</strong></p>
                                            </div>
                                        </section>
                                    )}
                                    {this.state.uploadFiles.length > 0 && (
                                        <aside className="d-flex flex-column file-list">
                                            <ul>{files}</ul>
                                        </aside>
                                    )}
                                </>
                            )}
                        </Dropzone>
                        {this.state.uploadFiles.length === 0 && (
                            <div className="bulkInvoiceImportPanel">
                                <Link to="#" className="templateLink" onClick={this.downloadTemplate}>Download Template</Link>
                            </div>
                        )}
                    </Modal.Body>
                    {
                        <Modal.Footer>

                        </Modal.Footer>
                    }
                </Modal >
            </>
        )
    }
}